import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropZoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 53,
	height: 53,
	viewBox: "0 0 53 53",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6380_45127)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 26.5,
				cy: 26.5,
				r: 26.5,
				fill: "url(#paint0_linear_6380_45127)"
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_6380_45127)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M31.2435 35.0065L17.145 43.1463C15.9608 43.83 14.4466 43.4242 13.7629 42.2401L2.9098 23.442C2.22611 22.2578 2.63185 20.7436 3.81603 20.0599L13.1299 14.6826L24.0591 17.611L32.1497 31.6244C32.8334 32.8086 32.4277 34.3228 31.2435 35.0065Z",
					fill: "url(#paint1_linear_6380_45127)",
					stroke: "#98A2B3",
					strokeWidth: .5
				}), /* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter0_d_6380_45127)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M13.5898 14.8057L23.6017 17.4884L19.3986 19.915C18.2145 20.5987 16.7002 20.193 16.0165 19.0088L13.5898 14.8057Z",
						fill: "white"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M13.5898 14.8057L23.6017 17.4884L19.3986 19.915C18.2145 20.5987 16.7002 20.193 16.0165 19.0088L13.5898 14.8057Z",
						stroke: "#98A2B3",
						strokeWidth: .5
					})]
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.9841 43.1448L21.8855 35.005C20.7014 34.3213 20.2956 32.8071 20.9793 31.6229L31.8324 12.8248C32.5161 11.6406 34.0303 11.2349 35.2145 11.9186L44.5283 17.296L47.4568 28.2252L39.3662 42.2386C38.6825 43.4227 37.1683 43.8285 35.9841 43.1448Z",
				fill: "url(#paint2_linear_6380_45127)",
				stroke: "#98A2B3",
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter1_d_6380_45127)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M44.6484 17.7549L47.3311 27.7668L43.128 25.3401C41.9438 24.6564 41.5381 23.1422 42.2217 21.958L44.6484 17.7549Z",
					fill: "white"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M44.6484 17.7549L47.3311 27.7668L43.128 25.3401C41.9438 24.6564 41.5381 23.1422 42.2217 21.958L44.6484 17.7549Z",
					stroke: "#98A2B3",
					strokeWidth: .5
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip2_6380_45127)",
				children: [/* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter2_dd_6380_45127)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M36.4675 43.6969H16.6675C15.0044 43.6969 13.6562 42.3487 13.6562 40.6857V14.2857C13.6562 12.6226 15.0044 11.2744 16.6675 11.2744H29.7479L39.4787 21.0053V40.6857C39.4787 42.3487 38.1305 43.6969 36.4675 43.6969Z",
						fill: "url(#paint3_linear_6380_45127)"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M36.4675 43.6969H16.6675C15.0044 43.6969 13.6562 42.3487 13.6562 40.6857V14.2857C13.6562 12.6226 15.0044 11.2744 16.6675 11.2744H29.7479L39.4787 21.0053V40.6857C39.4787 42.3487 38.1305 43.6969 36.4675 43.6969Z",
						stroke: "#98A2B3",
						strokeWidth: .5
					})]
				}), /* @__PURE__ */ _jsxs("g", {
					filter: "url(#filter3_d_6380_45127)",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M30.1562 11.6836L39.0704 20.5977H33.1675C31.5045 20.5977 30.1562 19.2495 30.1562 17.5865V11.6836Z",
						fill: "white"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M30.1562 11.6836L39.0704 20.5977H33.1675C31.5045 20.5977 30.1562 19.2495 30.1562 17.5865V11.6836Z",
						stroke: "#98A2B3",
						strokeWidth: .5
					})]
				})]
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 19.0664,
				y: 34.9854,
				width: 15,
				height: 15,
				rx: 7.5,
				fill: "#182230"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5664 39.8604V45.1104M23.9414 42.4854H29.1914",
				stroke: "#FCFCFD",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6380_45127",
			x: 10.0718,
			y: 12.4082,
			width: 17.1777,
			height: 12.0889,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6380_45127",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_d_6380_45127",
			x: 38.6396,
			y: 15.1074,
			width: 12.0894,
			height: 17.1777,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6380_45127",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter2_dd_6380_45127",
			x: 7.40625,
			y: 9.02441,
			width: 38.3223,
			height: 44.9224,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 2,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect1_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 2,
					operator: "erode",
					in: "SourceAlpha",
					result: "effect2_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_6380_45127",
					result: "effect2_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_6380_45127",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter3_d_6380_45127",
			x: 26.9062,
			y: 9.08008,
			width: 15.7676,
			height: 15.7676,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6380_45127"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6380_45127",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_6380_45127",
			x1: 26.5,
			y1: 0,
			x2: 26.5,
			y2: 53,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F5F5F6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F5F5F6",
				stopOpacity: 0
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_6380_45127",
			x1: 7.59795,
			y1: 18.5514,
			x2: 20.3421,
			y2: 40.6249,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .147835,
				stopColor: "white"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FDFEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_6380_45127",
			x1: 38.4118,
			y1: 14.4396,
			x2: 25.6677,
			y2: 36.5131,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .147835,
				stopColor: "white"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FDFEFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_6380_45127",
			x1: 21.5684,
			y1: 11.9854,
			x2: 21.5684,
			y2: 42.9854,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .147835,
				stopColor: "white"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FDFEFF"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6380_45127",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 53,
				height: 53,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_6380_45127",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 27.1327,
				height: 27.1327,
				fill: "white",
				transform: "translate(-1 22.5664) rotate(-30)"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip2_6380_45127",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 51,
				height: 46,
				fill: "white",
				transform: "translate(1 11)"
			})
		})
	] })]
});
export default SvgDropZoneIcon;
